import { useRef, useState } from "react";

// Drag libero di finestre/pulsanti flottanti con posizione ricordata (localStorage)
export default function useDragPos(key, { filter = true } = {}) {
  const [pos, setPos] = useState(() => {
    try {
      const p = JSON.parse(localStorage.getItem("dragpos_" + key));
      if (p && p.x >= 0 && p.x < window.innerWidth - 40 && p.y >= 0 && p.y < window.innerHeight - 40) return p;
    } catch { /* ignora */ }
    return null;
  });
  const ref = useRef(null);
  const movedRef = useRef(false);

  const start = (e) => {
    if (e.pointerType === "mouse" && e.button !== 0) return;
    if (filter && e.target.closest("button, a, input, select, textarea, video")) return;
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const sx = e.clientX, sy = e.clientY;
    movedRef.current = false;
    const mv = (ev) => {
      const dx = ev.clientX - sx, dy = ev.clientY - sy;
      if (!movedRef.current && Math.abs(dx) + Math.abs(dy) < 5) return;
      movedRef.current = true;
      const x = Math.min(Math.max(r.left + dx, 4), window.innerWidth - 60);
      const y = Math.min(Math.max(r.top + dy, 4), window.innerHeight - 40);
      setPos({ x, y });
    };
    const up = () => {
      window.removeEventListener("pointermove", mv);
      window.removeEventListener("pointerup", up);
      window.removeEventListener("pointercancel", up);
      if (movedRef.current) {
        setPos((p) => {
          if (p) localStorage.setItem("dragpos_" + key, JSON.stringify(p));
          return p;
        });
      }
    };
    window.addEventListener("pointermove", mv);
    window.addEventListener("pointerup", up);
    window.addEventListener("pointercancel", up);
  };

  const consumeMoved = () => {
    const m = movedRef.current;
    movedRef.current = false;
    return m;
  };
  const style = pos ? { left: pos.x, top: pos.y, right: "auto", bottom: "auto" } : {};
  return { ref, style, start, consumeMoved };
}
